// HQS-2390. The platform sends timestamps in two shapes. The device adapter's are Java
// `Instant`s and carry a zone -- `2026-09-09T15:53:45.713767Z`. The portal's are
// `LocalDateTime`s, which carry UTC wall-clock digits and no offset at all --
// `2026-09-09T15:53:45.713767`. ECMAScript reads a date-time without an offset as
// *local*, so the second shape is adopted unshifted and the browser then renders UTC
// digits as though they were local time.
//
// Supplying the missing `Z` is the whole of the fix. A value that already names a zone
// is parsed as it stands, so this keeps working unchanged once the platform sends
// offsets everywhere.
//
// Date-only values are deliberately not matched: ECMAScript already reads those as UTC.
const OFFSETLESS_DATE_TIME = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

/**
 * Parses a backend timestamp into the instant it denotes, so that rendering it with the
 * browser's locale shows the user's own local time.
 *
 * Returns `undefined` for an absent or unparseable value rather than an `Invalid Date`,
 * which formats as `Invalid Date` on screen and compares false against every threshold.
 */
export function parseBackendTimestamp(value?: string | null): Date | undefined {
  if (!value) return undefined;

  const parsed = new Date(OFFSETLESS_DATE_TIME.test(value) ? `${value}Z` : value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}
